import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AssignemntAcceptedListingModel } from 'common/models/page-models/Assignment Accepted Model/assignment-accepted-params.model';
import { AssignmentModel } from 'common/models/page-models/Assignments Model/assignment-data.model';
import { NotificationModel } from 'common/models/page-models/notification/notification-data.model';
import { NotificationMetaModel } from 'common/models/page-models/notification/notification-form-meta.model';
import { WidgetModel } from 'common/models/utility-models/base-model';
import { GridWidgetModel } from 'common/models/utility-models/list-utility.model';

import { GridResolver } from 'common/resolvers/core-resolvers/grid.resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { AssigmentNotAcceptedGridWidgetService } from 'common/widget/assignment/assigment-not-accepting-grid-widget.service';
import { AssigmentAcceptedGridWidgetService } from 'common/widget/assignment/assignment-accepting-grid-widget.service';
import { AssignmentGridWidgetService } from 'common/widget/assignment/assignment-grid-widget.service';
import { InvitedGridWidgetService } from 'common/widget/assignment/invited-grid-widget.service';


@Injectable({
    providedIn: 'root'
})
export class AssigmentAcceptedGridResolver extends GridResolver<AssignmentModel, AssignemntAcceptedListingModel> {
    constructor(
        protected fs: AssigmentAcceptedGridWidgetService,
        protected override router: Router,
        protected override systemService: SystemService
    ) {
        super(fs, router, systemService);

    }

    override initWidget(envelopeType: any, transferData: any): WidgetModel {
        const widget = new GridWidgetModel();
        const metaModel = this.pageService.getMetaModel();
        widget.recordPerPage = metaModel.properties?.recordPerPage;
        widget.searchableFeilds = metaModel.properties?.searchableFields;
        transferData.formData = new NotificationModel();
        transferData.formMeta = new NotificationMetaModel().getMetaModel();
        // this.fs.getFilterOptions(transferData.filterMeta);
        widget.transferData = transferData;
        return widget;
    }

}
